import {useMutation} from "@tanstack/react-query";
import {openExpedientCustomerOfferFromTemplateMutationOptions} from "./open-expedient-customer-offer-from-template.mutation-options";

export function useOpenExpedientCustomerOfferFromTemplate(id: string) {
  return useMutation(openExpedientCustomerOfferFromTemplateMutationOptions(id));
}
